import React, { useEffect, useMemo, useState } from 'react';

export default function TemplateCanvas({ html = '', onChange, isReadOnly = false }) {
  const [content, setContent] = useState('');

  const extractBodyHtml = (raw) => {
    if (!raw) return '';
    try {
      if (typeof window !== 'undefined' && raw.includes('<body')) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(raw, 'text/html');
        let bodyHtml = doc?.body?.innerHTML?.trim() ?? raw;
        bodyHtml = bodyHtml
          ?.replace(/>\s+</g, '><')
          ?.replace(/^\s+/, '') 
          ?.replace(/\s+$/, '');
        return bodyHtml;
      }
    } catch {}
    return raw;
  };

  useEffect(() => {
    const next = extractBodyHtml(html);
    setContent(next);
    onChange && onChange(next);
  }, [html]);

  const bgColor = useMemo(() => {
    const match = html?.match(/background-color:\s*([^;}"']+)/i);
    return match ? match[1].trim() : '#ffffff';
  }, [html]);

  return (
    <div
      className='email-template-canvas template-preview-canvas'
      style={{
        border: '1px solid #E6E6E6',
        borderRadius: 8,
        background: bgColor,
        minHeight: 550,
        maxWidth: 1000,
        margin: '0 auto',
        overflow: 'hidden',
      }}
    >
      <div
        className='template-html-preview'
        style={{
          padding: '20px',
          maxHeight: '550px',
          backgroundColor: bgColor,
          overflowY: 'scroll',
        }}
        dangerouslySetInnerHTML={{ __html: content }}
      />
    </div>
  );
}
